import { IconButton, makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow as TableRowBase, withStyles } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveAltIcon from '@material-ui/icons/Done';
import * as React from 'react';
import { useContext } from 'react';
import { ReadOnly } from './inputs';

export const InlineTable = ( { head = undefined, children, ...rest } ) => {
    return rest.noBorders ? 
            <InlineTableContainer><InlineTableContent head={head} {...rest}>{children}</InlineTableContent></InlineTableContainer> 
            : <InlineTableContent head={head} {...rest}>{children}</InlineTableContent>;
}

export const InlineTableContainer  = ( { children, ...rest } ) => {
    const classes = useInlineTableContainerStyles( rest );

    return (
        <TableContainer classes={classes}>
            {children}
        </TableContainer>
        );
}

const useInlineTableContainerStyles = makeStyles({
    root : {
        '& table' : {
            marginLeft: 0,
            width: '100%',
        }
    }
})

const InlineTableContent = ( { head = undefined, children, headerOnly = false, ...rest } ) => {
    const classes = useInlineTableContentStyles( rest );

    return (children && children.length) || headerOnly ?
            <Table classes={ classes }>
                { head &&
                    <TableHead>
                        { head }
                    </TableHead>
                }
                <TableBody>
                    { children }
                </TableBody>
            </Table>
            : <div/>
}

const useInlineTableContentStyles = makeStyles({
    root : {
        '& td' : {
            borderBottom: ( props : any ) => props.noRowBorders ? 0 : 1
        }
    }
})

export const TableHeader = withStyles({
    root : {
        backgroundColor : '#F2F6F8',

        '& th' : {
            color: '#899095',
            fontFamily: 'Montserrat',
            fontSize: 14,
            textTransform : 'uppercase',
            height: 40,
            paddingTop : 0,
            paddingBottom : 0,
        }
    }
})( TableRowBase )

const cellStyle = {
    color: '#101010',
    fontFamily: 'Montserrat',
    fontSize: 14,
    height: 40,
    paddingTop : 0,
    paddingBottom : 0,
}

export const TableTotals = withStyles({
    root : {
        '& td' : {
            ...cellStyle,
            fontWeight : 500
        }
    },
})( TableRowBase )

export const TableRow = withStyles({
    root : {
        '&:not(.group)' : {
            cursor : 'pointer',
        },

        '&:hover:not(.group)' : {
            '& button' : {
                visibility: 'visible'
            },

            backgroundColor : '#f0f0f0'
        },

        '& button' : {
            visibility: 'hidden'
        },

        '& td.small' : {
            width: '100px'
        },

        '& td.medium' : {
            width: '140px'
        },

        '& td.fit-width' : {
            width: '1%',
            whiteSpace : 'nowrap'
        },

        '& td.fit-width-tight' : {
            width: '1%',
            whiteSpace : 'nowrap',
            padding: '0px'
        },

        '& td.xlarge' : {
            width: '250px'
        },

        '&.dark' : {
            '& td' : {
                color: '#668AA5',
                backgroundColor: '#F1F5F8',
            }
        },
        '&.green' : {
            '& td' : {
                color: '#668AA5',
                backgroundColor: '#cfefc2',
            }
        },

        '& td' : cellStyle
    },
})( TableRowBase )

export const RowEditActions = ({ onSave, onCancel }) =>
        <TableCell className="fit-width">
            <IconButton aria-label="Save" size="small" onClick={ onSave }>
                <SaveAltIcon />
            </IconButton>

            <IconButton aria-label="Cancel" size="small" onClick={ onCancel }>
                <CancelIcon />
            </IconButton>
        </TableCell>


export const RowActions = ({ onEdit, onDelete } : {
    onEdit? : () => void
    onDelete? : () => void
}) => {
    const readOnly = useContext( ReadOnly );

    return (
        <TableCell className="fit-width">
            { !readOnly && onEdit &&
                <IconButton aria-label="Edit" size="small" onClick={ onEdit }>
                    <EditIcon />
                </IconButton>
            }

            { !readOnly && onDelete &&
                <IconButton aria-label="Remove" size="small" onClick={ onDelete }>
                    <DeleteIcon />
                </IconButton>
            }
        </TableCell>
    )
}

export { TableCell } from '@material-ui/core';

